import { render } from "./ForkKnife.vue?vue&type=template&id=90c57f36"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ForkKnife.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90c57f36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90c57f36', __exports__)) {
    api.reload('90c57f36', __exports__)
  }
  
  module.hot.accept("./ForkKnife.vue?vue&type=template&id=90c57f36", () => {
    api.rerender('90c57f36', render)
  })

}


export default __exports__